export const convertTimeToNumber = (time: string) => {
  const timeArr = time.split(':');

  return +timeArr[0] * 3600 + +timeArr[1] * 60 + +timeArr[2];
};
